import 'angular:locale/data:es';
import '@angular/localize/init';
import 'zone.js';(globalThis.$localize ??= {}).locale = "es";
